fragment contactFragment on Contact {
  id
  name
  phone
  email
  comment
  channels
}
